var _path, _line, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagazines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 168,
    viewBox: "0 0 129 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.67029 4C1.67029 2.61929 2.78957 1.5 4.17029 1.5H124.83C126.211 1.5 127.33 2.61928 127.33 4V66.5153C127.33 67.8961 126.211 69.0153 124.83 69.0153H98.6342H23.1452H4.17029C2.78958 69.0153 1.67029 67.896 1.67029 66.5153V4Z",
    stroke: "black",
    strokeWidth: 3
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1.99951,
    y1: 110.501,
    x2: 127.414,
    y2: 110.501,
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "10 5"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 1.99939,
    y1: 95.5,
    x2: 127.414,
    y2: 95.5,
    stroke: "#F2C0C1",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "10 5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagazines);
export default __webpack_public_path__ + "static/media/magazines.43770b34871a124956737655b1a4ca77.svg";
export { ForwardRef as ReactComponent };